// src/hooks/useDragScroll.js
// 가로 스크롤 영역을 마우스로 드래그해서 스크롤할 수 있도록 한다.
// - 모바일 터치 스크롤은 브라우저 기본 동작으로 이미 지원되므로 건드리지 않음
// - PC 마우스에서만 동작
// - 드래그 후 발생하는 click 이벤트는 흡수해 버튼이 잘못 눌리지 않게 함
import { useEffect } from "react";

export default function useDragScroll(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    const MOVE_THRESHOLD = 5;

    const onMouseDown = (e) => {
      // 좌클릭만 처리
      if (e.button !== 0) return;
      // ✅ 브라우저 기본 이미지/텍스트 드래그 동작 차단 (없으면 카드 잡을 때 드래그 고스트가 떠서 스크롤이 막힘)
      e.preventDefault();
      isDown = true;
      moved = false;
      startX = e.pageX - el.offsetLeft;
      startScrollLeft = el.scrollLeft;
      el.style.cursor = "grabbing";
      el.style.userSelect = "none";
    };

    // ✅ 컨테이너 내부 요소들의 native dragstart 도 차단 (특히 <img>)
    const onDragStart = (e) => {
      e.preventDefault();
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      const x = e.pageX - el.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > MOVE_THRESHOLD) moved = true;
      el.scrollLeft = startScrollLeft - walk;
    };

    const finishDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.style.cursor = "";
      el.style.userSelect = "";

      // 드래그 직후 발생할 click을 한 번만 차단 (버튼 오클릭 방지)
      if (moved) {
        const cancelClick = (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
        };
        el.addEventListener("click", cancelClick, { capture: true, once: true });
        // 안전장치: 다음 틱에 핸들러가 제거되도록
        setTimeout(() => {
          el.removeEventListener("click", cancelClick, { capture: true });
        }, 0);
      }
    };

    el.addEventListener("mousedown", onMouseDown);
    el.addEventListener("dragstart", onDragStart);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", finishDrag);

    return () => {
      el.removeEventListener("mousedown", onMouseDown);
      el.removeEventListener("dragstart", onDragStart);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", finishDrag);
    };
  }, [ref]);
}
